import { MouseEventHandler } from "react";
import Icon from "../../common/Icon";
import styles from "./SideNav.module.css";

export interface SideNavItems {
    icon?: string;
    label?: string;
    onClick?: MouseEventHandler<HTMLElement>;
    isActive?: boolean;
}

/**
 * @author cwlee
 * @date 2024-08-21 17:28:47
 * @remark 사이드 레일 상단 네비게이션 + 공유
 * @params
 * icon : 아이콘이름
 * label : 아이콘 라벨
 * onclick : 클릭시 실행함수
 * isActive : 활성화 여부
 *
 * @returns
 */
const SideNav = (props: SideNavItems) => {
    return (
        <div className={`${styles["wrapper"]} ${props.isActive ? styles.active : ""}`} onClick={props.onClick}>
            {props.icon && <Icon name={props.icon} color={props.isActive ? "white" : "darkGrey"} />}
            {props.label && <span className={`${styles.label}`}>{props.label}</span>}
        </div>
    );
};

export default SideNav;
